import { VisitorRegistrationRequest } from '../types';

// 전화번호 형식 검증 (010으로 시작하는 11자리)
export const validatePhone = (phone: string): boolean => {
  // 하이픈 제거
  const cleanPhone = phone.replace(/-/g, '');
  // 010으로 시작하는 11자리 숫자
  const phoneRegex = /^010\d{8}$/;
  return phoneRegex.test(cleanPhone);
};

// 이메일 형식 검증
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// 전체 폼 검증
export const validateForm = (formData: VisitorRegistrationRequest): { [key: string]: string } => {
  const errors: { [key: string]: string } = {};

  // 이름 검증
  if (!formData.visitor_name.trim()) {
    errors.visitor_name = '이름을 입력해주세요.';
  }

  // 전화번호 검증
  if (!formData.visitor_phone.trim()) {
    errors.visitor_phone = '전화번호를 입력해주세요.';
  } else if (!validatePhone(formData.visitor_phone)) {
    errors.visitor_phone = '휴대폰 번호는 010으로 시작하는 11자리 숫자여야 합니다.';
  }

  // 이메일 검증
  if (!formData.visitor_email.trim()) {
    errors.visitor_email = '이메일을 입력해주세요.';
  } else if (!validateEmail(formData.visitor_email)) {
    errors.visitor_email = '올바른 이메일 형식이 아닙니다.';
  }

  // 회사명 검증
  if (!formData.visitor_company_name.trim()) {
    errors.visitor_company_name = '회사명을 입력해주세요.';
  }

  // 회사 주소 검증
  if (!formData.visitor_company_address.trim()) {
    errors.visitor_company_address = '회사 주소를 입력해주세요.';
  }

  // 상세 주소 검증
  if (!formData.visitor_company_detail_address.trim()) {
    errors.visitor_company_detail_address = '상세 주소를 입력해주세요.';
  }

  // 직급 검증
  if (!formData.visitor_position.trim()) {
    errors.visitor_position = '직급을 입력해주세요.';
  }

  return errors;
};

// 전화번호 포맷팅 (자동 하이픈 추가)
export const formatPhoneNumber = (value: string): string => {
  // 숫자만 추출
  const numbers = value.replace(/[^\d]/g, '');

  // 010-1234-5678 형식으로 포맷팅
  if (numbers.length <= 3) {
    return numbers;
  } else if (numbers.length <= 7) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  } else if (numbers.length <= 11) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
  }

  // 11자리 초과 시 11자리까지만
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
};
